import ArrowDown from "@styles/all-images/icons/arrow-down.svg";
import EyeIcon from "@styles/all-images/icons/eye-blue.svg";
import TimeBlueIcon from "@styles/all-images/icons/timeblue.svg";
import FileIcon from "@styles/all-images/icons/file.svg";
import { useNavigate } from "react-router-dom";
import { useState } from "react";

interface AnnualFinancialStatementsProps {
  onClose: () => void;
  onSubmit: () => void;
}

const AnnualFinancialStatements = ({
  onClose,
  onSubmit,
}: AnnualFinancialStatementsProps) => {
  const navigate = useNavigate();
  const [currentPage] = useState(1);
  const [rowsPerPage] = useState(5);
  const [searchTerm] = useState("");

  const staffData = [
    {
      docName: "Financial Statement Year 1 (Unaudited)",
      uploadedOn: "02/12/2024 16:20 ",
      status: "Approved",
    },
    {
      docName: "Financial Statement Year 1 (Audited)",
      uploadedOn: "02/12/2024 16:20 ",
      status: "Approved",
    },
    {
      docName: "Financial Statement Year 2 (Audited)",
      uploadedOn: "02/12/2024 16:20 ",
      status: "Approved",
    },
    {
      docName: "Financial Statement Year 3 (Audited)",
      uploadedOn: "02/12/2024 16:20 ",
      status: "Approved",
    },
  ];
  const filteredData = staffData.filter((staff) =>
    Object.values(staff).some((value) =>
      value.toString().toLowerCase().includes(searchTerm.toLowerCase()),
    ),
  );

  const currentData = filteredData.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage,
  );

  return (
    <div className="tw-relative">
      {/* Main Content */}
      <div className="tw-p-6 tw-mt-[147px] tw-gap-6 tw-flex-col tw-flex">
        <div>
          <h2 className="tw-text-[#414651] tw-text-base tw-font-semibold">
            Annual Financial Statements (3 Years) & Auditor’s Report (FIN OB 2){" "}
          </h2>
        </div>
        <div className="tw-bg-white tw-rounded-lg tw-border tw-border-[#E9EAEB] tw-shadow tw-overflow-hidden">
          <table className="tw-w-full">
            <thead>
              <tr className="tw-border-b">
                <th className="tw-px-6 tw-py-4 tw-text-left tw-text-xs font-weight-medium tw-text-[#535862] tw-flex tw-items-center tw-gap-1">
                  Document name
                  <img
                    src={ArrowDown}
                    alt="Arrow Down"
                    className="tw-w-5 tw-h-5"
                  />
                </th>

                <th className="tw-px-6 tw-py-4 tw-text-left tw-text-xs font-weight-medium tw-text-[#535862]">
                  <div className="tw-flex tw-items-center tw-gap-2">
                    Uploaded on
                    <img
                      src={ArrowDown}
                      alt="Arrow Down"
                      className="tw-w-5 tw-h-5"
                    />
                  </div>
                </th>
                <th className="tw-px-6 tw-py-4 tw-text-left tw-text-xs font-weight-medium tw-text-[#535862]">
                  status
                </th>
                <th className="tw-px-6 tw-py-4 tw-text-left tw-text-xs font-weight-medium tw-text-[#535862]">
                  Action
                </th>
              </tr>
            </thead>
            <tbody className="tw-divide-y tw-divide-gray-200">
              {currentData.map((staff, index) => (
                <tr key={index} className="tw-hover:bg-gray-50">
                  <td className="tw-px-6 tw-py-3 tw-text-sm font-weight-base font-primary-color tw-flex tw-items-center tw-gap-2">
                    <span className="tw-w-9 tw-h-9 tw-rounded-full tw-bg-[#F4EBFF] tw-flex tw-items-center tw-justify-center">
                      <img
                        src={FileIcon}
                        alt=""
                        className="tw-w-auto tw-h-auto"
                      />
                    </span>
                    {staff.docName}
                  </td>
                  <td className="tw-px-6 tw-py-3 tw-text-sm font-weight-base font-primary-color">
                    {staff.uploadedOn}
                  </td>
                  <td className="tw-px-6 tw-py-3 tw-text-sm">
                    <li
                      className={`tw-px-2 tw-py-1 tw-flex tw-items-center tw-gap-2 tw-rounded-full tw-text-sm tw-w-fit ${
                        staff.status === "Approved"
                          ? "tw-bg-[#ECFDF3] tw-text-[#027A48]"
                          : "tw-bg-[#F5F5F5] tw-text-[#414651]"
                      }`}
                    >
                      <span
                        className={`tw-w-2 tw-h-2 tw-rounded-full ${
                          staff.status === "Approved"
                            ? "tw-bg-[#12B76A]"
                            : "tw-bg-[#717680]"
                        }`}
                      ></span>
                      {staff.status}
                    </li>
                  </td>
                  <td className="tw-px-6 tw-py-3 tw-text-sm tw-flex tw-items-center tw-gap-6">
                    <button
                      onClick={() =>
                        navigate("/approved-on-boarding-document-show")
                      }
                    >
                      <img
                        src={EyeIcon}
                        alt="Lock Icon"
                        className="tw-w-auto tw-h-auto"
                      />
                    </button>
                    <button
                      onClick={() =>
                        navigate(
                          "/approved-on-boarding-document-change-history",
                        )
                      }
                    >
                      <img
                        src={TimeBlueIcon}
                        alt="Lock Icon"
                        className="tw-w-auto tw-h-auto"
                      />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default AnnualFinancialStatements;
